import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { CONSTANT, GridDataSource, LoaderService, NotificationService, TYPEMODULE } from 'src/app/shared/session';
import { UserService } from '../../user/shared/user.service';
import { NivelAccesoService } from '../../nivelAcceso/shared/nivel-acceso.service';
import { NivelAcceso } from '../../nivelAcceso/shared/nivel-acceso.model';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model';
import { AccesoUsuarioService } from '../shared/acceso-usuario.service';
import { Entidad } from '../../entidad/shared/entidad.model';
import { EntidadService } from '../../entidad/shared/entidad.service';

@Component({
  selector: 'app-acceso-usuario-list',
  templateUrl: './acceso-usuario-list.component.html',
})
export class AccesoUsuarioListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;

  pageSize: number;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  pageEvent: PageEvent;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
  nivelesAcceso: NivelAcceso[];
  idNivelAcceso: number;
  aplicaciones: Aplicacion[];
  idAplicacion: number;
  entidades: Entidad[] = [];
  idEntidad: number;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NotificationService,
    private nivelAccesoService: NivelAccesoService,
    private aplicacionService: AplicacionService,
    private accesoUsuarioService: AccesoUsuarioService,
    private entidadService: EntidadService,
  ) { }

  ngOnInit() {
    this.pageSize = 0;
    this.pageEvent = new PageEvent();
    this.msgErrorGet = 'Error al listar los Usuarios';
    this.displayedColumns = ['indCheck', 'UserID', 'Name', 'Descripcion', 'Status'];
    this.initData();
  }

  async initData() {
    this.loaderService.show();
    this.aplicaciones = await this.aplicacionService.listarApplication().toPromise();
    this.idAplicacion = this.aplicaciones[0].ID;
    this.nivelesAcceso = await this.nivelAccesoService.listarNivelAcceso().toPromise();
    this.idNivelAcceso = this.nivelesAcceso[0].id;
    await this.listarEntidad();
    this.loaderService.hide();
  }

  async listarEntidad() {
    this.entidades = await this.entidadService.listByNivelAcceso(this.idNivelAcceso).toPromise();
    if (this.entidades.length > 0) {
      this.idEntidad = this.entidades[0].id;
      this.listarAccesoUsuario();
    } else {
      this.notificationService.warning("No hay entidades registradas");
      this.dataSource = new GridDataSource([]);
      this.showHideMessageGridEmpty(0);
      this.idEntidad = null;
    }
  }

  searchEmit() {
    this.listarAccesoUsuario();
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onChangeAplicacion() {
    this.listarAccesoUsuario();
  }

  onChangeNivelAcceso() {
    this.listarEntidad();
  }

  onChangeEntidad() {
    this.listarAccesoUsuario();
  }

  listarAccesoUsuario() {
    if (this.idAplicacion == null || this.idNivelAcceso == null || this.idEntidad == null)
      return;
    this.loaderService.show();
    this.userService.listarAccesoUsuario(this.sectionBarComponent.filtro, this.idAplicacion, this.idNivelAcceso, this.idEntidad, this.data.rol.ID)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  onChangeVinculacion(row: any) {
    this.guardarAccesoUsuario(row.ID);
  }

  guardarAccesoUsuario(idUsuario: number): void {
    this.loaderService.show();
    this.accesoUsuarioService.guardarAccesoUsuario(this.idAplicacion, this.idNivelAcceso, this.idEntidad, this.data.rol.ID, idUsuario)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}
